import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import emptySvg from '../../assets/empty.svg';
import peopleSvg from '../../assets/people.svg';
import warnSvg from '../../assets/warn.svg';
import classes from './ListMessage.module.css';
export const ListMessage = ({ type, children }) => {
    if (type === 'inline') {
        return _jsx("div", { className: classes.messageInline, children: children });
    }
    return (_jsx("div", { className: classes.messageContainer, children: _jsxs("div", { className: classes.messageContent, children: [type === 'empty' && _jsx("img", { className: classes.messageImage, src: emptySvg, alt: "empty" }), type === 'people' && _jsx("img", { className: classes.messageImage, src: peopleSvg, alt: "people" }), type === 'warning' && _jsx("img", { className: classes.messageImage, src: warnSvg, alt: "warning" }), children] }) }));
};
